module.exports = __webpack_public_path__ + "media/7.cdf89bf6.mp3";